import { useEffect, useState } from 'react';

const TYPE_STYLE = {
  added:    { bg: 'rgba(16, 185, 129, 0.25)', border: 'rgba(16, 185, 129, 0.7)' },
  removed:  { bg: 'rgba(239, 68, 68, 0.25)',  border: 'rgba(239, 68, 68, 0.7)' },
  modified: { bg: 'rgba(245, 158, 11, 0.25)', border: 'rgba(245, 158, 11, 0.7)' },
  visual:   { bg: 'rgba(239, 68, 68, 0.25)',  border: 'rgba(239, 68, 68, 0.6)' },
};

export default function ChangeBadge({ badge, isActive }) {
  const [pulse, setPulse] = useState(false);
  useEffect(() => {
    if (!isActive) return;
    setPulse(true);
    const t = setTimeout(() => setPulse(false), 1500);
    return () => clearTimeout(t);
  }, [isActive]);

  const style = TYPE_STYLE[badge.type] || TYPE_STYLE.visual;
  return (
    <div
      className={`absolute pointer-events-none rounded-sm transition-all ${pulse ? 'ring-2 ring-indigo-500' : ''}`}
      style={{
        left: badge.x, top: badge.y, width: badge.w, height: badge.h,
        background: style.bg,
        outline: `1px solid ${style.border}`,
      }}
    />
  );
}
